/**
 * Contact Form 7 Custom Submit Handler
 * Handles custom buttons with icons triggering CF7 form submission
 */

export function initCf7Forms() {
  
  const customSubmitButtons = document.querySelectorAll('.cf7-custom-submit');

  customSubmitButtons.forEach((button) => {
    console.log('[v0] Attaching listener to button:', button);
    button.addEventListener('click', handleCustomSubmit);
  });

  // Listen for CF7 events to reset button state
  document.addEventListener('wpcf7mailsent', handleFormSuccess);
  document.addEventListener('wpcf7mailfailed', handleFormError);
  document.addEventListener('wpcf7invalid', handleFormError);
  document.addEventListener('wpcf7submit', handleFormSubmitEnd);
}

function handleCustomSubmit(e) {
  const button = e.currentTarget;
  const form = button.closest('.wpcf7-form');
  
  if (!form) return;

  const realSubmit = form.querySelector('input[type="submit"]');
  
  if (realSubmit) {
    // Add submitting state to custom button
    button.classList.add('is-submitting');
    button.disabled = true;

    // Trigger the real CF7 submit
    realSubmit.click();
  }
}

function handleFormSuccess(e) {
  resetButton(e.target);
}

function handleFormError(e) {
  resetButton(e.target);
}

function handleFormSubmitEnd(e) {
  // Reset button after any submission attempt (valid or invalid)
  resetButton(e.target);
}

function resetButton(form) {
  const button = form.querySelector('.cf7-custom-submit');
  
  if (button) {
    button.classList.remove('is-submitting');
    button.disabled = false;
  }
}
